import {  Typography,TextField,InputAdornment,Button } from '@material-ui/core'
import { useState } from 'react';

import Email from '../assets/svg/Email.svg'
import NEUniteLogo from '../assets/svg/Logo.svg'
import { useNotFoundStyles } from '../styles/muiStyles';
import { useMutation } from '@apollo/client';
import { RESET_PASSWORD} from '../graphql/mutations';

import { useApolloClient } from '@apollo/client';
import { getErrorMsg } from '../utils/helperFuncs';
import ErrorMessage from '../components/ErrorMessage';



import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import{ useForm } from 'react-hook-form';
import EmailIcon from '@material-ui/icons/Email';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { useHistory } from "react-router-dom";



const validationSchema = yup.object({
    email: yup
        .string()
        .required('Required')
        .email(),
});

const ResetPassword = () =>{
    let history = useHistory();
    const classes= useNotFoundStyles();
    const [errorMsg, setErrorMsg] = useState(null);

    const client = useApolloClient();
    
    const { register, handleSubmit, reset, errors } = useForm({
        mode: 'onChange',
        resolver: yupResolver(validationSchema),
    });

    const [resetPassword, { loading }] = useMutation(RESET_PASSWORD, {
        onError: (err) => {
            setErrorMsg(getErrorMsg(err));
        },
    });
    
    const onReset = ({ email}) => {
        resetPassword({
            variables: { email },
            update: (_,) => {
                history.push("/email-confirmation-notice");
                reset();
            },
        });
            client.clearStore();
    };
    
    return (
        <div>
            <div style={{display:'flex',alignItems:'center',}}>
                <img src={NEUniteLogo} alt="logo" style ={{width:'5vw', height:'5vw', margin:'1.5vw'}} />
                <Typography variant='h6' style={{color:'white',textShadow: '2px 2px #7a7878', letterSpacing:'.3vw'}}>
                        <strong> <i>NEUMeet</i></strong>
                </Typography>
            </div>
            <div className = {classes.root} >
                <div>
                    <img src={Email} alt="Sent email" />
                </div>
                <form onSubmit={handleSubmit(onReset)} className={classes.form}>
                <div  style ={{textAlign:'center'}}>
                    <Typography variant='h4'  style ={{marginBottom:'1vw', letterSpacing:'.3vw'}}>
                        <strong> <i>Please Enter you email</i></strong>
                    </Typography>
                    <TextField
                        required
                        fullWidth
                        inputRef={register}
                        name="email"
                        type="text"
                        label="Email"
                        variant="outlined"
                        error={'email' in errors}
                        helperText={'email' in errors ? errors.email.message : ''}
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                                <EmailIcon color="primary" />
                            </InputAdornment>
                            ),
                        }}
                    />
                    <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        fullWidth
                        startIcon={<PersonAddIcon />}
                        type="submit"
                        disabled={loading}
                        className={classes.submitButton}
                    >
                        Send Email
                    </Button>
                    <ErrorMessage
                        errorMsg={errorMsg}
                        clearErrorMsg={() => setErrorMsg(null)}
                    />
                </div> 
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
